import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ApexAxisChartSeries, ApexChart, ApexDataLabels, ApexPlotOptions, ApexXAxis, ApexYAxis } from 'ng-apexcharts';
import { forkJoin } from 'rxjs';
import { DealsService } from 'src/app/services/deals.service';
import { PerformanceReportService } from 'src/app/services/report/performance-report.service';
import { AppState } from 'src/app/store/app.state';
import DateUtils from 'src/app/utils/date';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  colors: string[]
};
@Component({
  selector: 'app-percentage-won-lost',
  templateUrl: './percentage-won-lost.component.html',
  styleUrls: ['./percentage-won-lost.component.css']
})
export class PercentageWonLostComponent implements OnInit {
  id;
  type;
  all;
  part;
  datas;
  payload;
  showGraph = false;
  selectedIds = null;
  selectedType = null;
  selectedPeriod = 'monthly'
  dateUtil = new DateUtils;
  selectedYr = new Date().getFullYear();
  public chartOptions = {
    series: [
      {
        name: "Deal Won",
        data: []
      },
      {
        name: "Deal Lost",
        data: []
      },
    ],
    chart: {
      type: "bar",
      height: 300
    },
    plotOptions: {
      bar: {
        horizontal: false,
      }
    },
    dataLabels: {
      enabled: false
    },
    xaxis: {
      categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
      title: {
        text: 'Months',
      },
    },
    yaxis: {
      title: {
        text: 'Percentage (%)',
      },
      labels: {
        formatter: function (value) {
          return new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(value)
        }
      },

    },
    colors: [
      "#00c851", "#DC3545",
    ]
  };

  constructor(
    private dealSrv: DealsService,
    private performRepSrv: PerformanceReportService,
  ) {
    this.performRepSrv.selected_users.subscribe(res => {
      if (res && res.type) {
        const { ids, type } = res;
        this.selectedIds = ids;
        this.selectedType = type;
        this.handleDateFilter()
      }
    })
  }

  ngOnInit() {
    this.handleDateFilter();
  }

  handleDateFilter() {
    this.showGraph = false;
    this.getId();
    this.getData();
  }

  dateChange({ selectedPeriod, selectedYr }) {
    this.selectedYr = selectedYr;
    this.selectedPeriod = selectedPeriod;
    this.handleDateFilter();
  }

  partCount(data) {
    const part = data.map(p => p.part)
    const quarters = { 1: 0, 2: 0, 3: 0, 4: 0 };
    part.forEach((m, i) => {
      const q = this.dateUtil.getQuarter(i)
      let count = quarters[q];
      if (count || count === 0) {
        count = m + count
      }
      quarters[q] = count;
    });
    const result = [];
    Object.values(quarters).forEach(q => result.push({ part: q }))
    this.part = result;

  }

  allCount(data) {
    const all = data.map(a => a.all);
    const quarters = { 1: 0, 2: 0, 3: 0, 4: 0 };
    all.forEach((m, i) => {
      const q = this.dateUtil.getQuarter(i)
      let count = quarters[q];
      if (count || count === 0) {
        count = m + count
      }
      quarters[q] = count;
    });
    const result = [];
    Object.values(quarters).forEach(q => result.push({ all: q }))
    this.all = result;
  }

  getId() {
    this.resetGraph();
    let type = this.selectedType === "salesperson" ? 3 : this.selectedType === "team" ? 2 : null;
    this.payload = {
      startDate: this.selectedYr,
      id: this.selectedIds ? this.selectedIds.map(i => i.toString()) : null,
      type: type || 3,
    };
  }

  getData() {
    const won = { ...this.payload, status: 2 };
    const lost = { ...this.payload, status: 1 };
    const delaWon = this.dealSrv.fetchDealsStatusPercentage(won);
    const dealLost = this.dealSrv.fetchDealsStatusPercentage(lost);
    forkJoin([delaWon, dealLost]).subscribe((responses: any) => {
      //map all the allWon variable into an array
      const allWon = responses[0].map(x => x.total);
      //map all the allWon variable into an array
      const allLost = responses[1].map(x => x.total);
      //sum the all Won and Lost array
      const allWonSum = allWon.reduce((a, b) => a + b)
      const allLostSum = allWon.reduce((a, b) => a + b)
      if (allWonSum == 0 && allLostSum == 0) {
        this.datas = []
      } else {
        this.datas = responses;
        this.singleDataValue(responses);
      }
      setTimeout(() => {
        this.showGraph = true;
      }, 500);
    })
  }

  singleDataValue(responses) {
    if (responses[0]) {
      const win = responses[0]
      const winMap = win.map(w => w.total)
      if (this.selectedPeriod === 'quaterly') {
        const quatersLabel = ['Q1', 'Q2', 'Q3', 'Q4'];
        this.partCount(win)
        this.allCount(win);
        const arr: any = new Array({}).fill(this.all.length);
        this.all.forEach((item, i) => {
          const objIndex = arr[i];
          arr[i] = { ...objIndex, ...item }
        })
        this.part.forEach((item, i) => {
          const objIndex = arr[i];
          arr[i] = { ...objIndex, ...item }
        })
        const result = arr.map(w => {
          const avg = w.part == w.all ? 0 : ((w.part / w.all) * 100);
          return { avg }
        })
        this.chartOptions.xaxis.title.text = "Quaters";
        this.chartOptions.xaxis.categories = quatersLabel;
        this.chartOptions.series[0].data = result.map(r => r.avg);
      } else {
        this.chartOptions.series[0].data = winMap;
        this.chartOptions.xaxis.categories = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
          this.chartOptions.xaxis.title.text = "Months";
      }
    }
    if (responses[1]) {
      const lost = responses[1]
      const lostMap = lost.map(w => w.total)
      if (this.selectedPeriod === 'quaterly') {
        const quatersLabel = ['Q1', 'Q2', 'Q3', 'Q4'];
        this.partCount(lost)
        this.allCount(lost);
        const arr: any = new Array({}).fill(this.all.length);
        this.all.forEach((item, i) => {
          const objIndex = arr[i];
          arr[i] = { ...objIndex, ...item }
        })
        this.part.forEach((item, i) => {
          const objIndex = arr[i];
          arr[i] = { ...objIndex, ...item }
        })
        const result = arr.map(w => {
          const avg = w.part == w.all ? 0 : ((w.part / w.all) * 100);
          return { avg }
        })
        this.chartOptions.xaxis.title.text = "Quaters";
        this.chartOptions.xaxis.categories = quatersLabel;
        this.chartOptions.series[1].data = result.map(r => r.avg);;
      } else {
        this.chartOptions.series[1].data = lostMap;
        this.chartOptions.xaxis.categories = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
          this.chartOptions.xaxis.title.text = "Months";
      }
    }
  }

  resetGraph() {
    this.chartOptions.series[0].data = [];
    this.chartOptions.series[1].data = [];
    this.showGraph = false;
  }

}
